import axios from "axios";

export function getVideoList(co) {
  const config = {
    params: co,
  };
  return axios.get(process.env.VUE_APP_API_URL + "Video/getlist", config);
}

export function getVideoListForPlaylist(co) {
  const config = {
    params: co,
  };
  //içeride değişiklik var
  return axios.get(process.env.VUE_APP_API_URL + "Video/getlistforplaylist", config);
}

export function postVideo(data) {
  return axios.post(process.env.VUE_APP_API_URL + "Video/add", data);
}

export function updateVideo(data) {
  return axios.put(process.env.VUE_APP_API_URL + "Video/update", data);
}

export function deleteVideo(videoId) {
  const config = {
    params: {
      videoId: videoId,
    },
  };

  return axios.delete(process.env.VUE_APP_API_URL + "Video/deleted", config);
}

export function postClassPersonelVideolist(data) {
  return axios.post(process.env.VUE_APP_API_URL + "Video/postClassPersonelVideolist", data);
}

export function getSuggestedVideolist() {
  return axios.get(process.env.VUE_APP_API_URL + "Video/getsuggestedvideolist");
}